export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20amber%20theater%20lighting%20and%20deep%20crimson%20velvet%20curtains%2C%20elegant%20film%20projector%20light%20beam%20cutting%20through%20subtle%20haze%2C%20luxurious%20gold%20accents%20on%20architectural%20details%2C%20rich%20dark%20background%20with%20soft%20bokeh%20highlights%2C%20sophisticated%20movie%20palace%20interior%20mood%2C%20high%20end%20editorial%20photography%20style%2C%20dramatic%20yet%20refined%20composition%2C%20no%20people%2C%20abstract%20cinema%20elegance&width=1920&height=1080&seq=hero-cinema-bg&orientation=landscape"
          alt="成全影院 - 沉浸式观影体验"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/15 mb-6 animate-fade-in-up">
                <i className="ri-fire-line text-accent-400 text-sm w-4 h-4 flex items-center justify-center"></i>
                <span className="text-xs md:text-sm text-white/90 whitespace-nowrap">高清不卡顿 · 海量片库 · 每日更新</span>
              </div>

              <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 animate-fade-in-up animation-delay-100">
                成全影院 - 免费电影电视剧<br className="hidden sm:block" />在线观看平台
              </h1>

              <p className="text-base md:text-lg text-white/70 mb-6 max-w-2xl lg:max-w-none leading-relaxed animate-fade-in-up animation-delay-200">
                成全影院为您打造一站式的免费观影体验。无论是最新上映的动作大片、经典怀旧的电视剧全集，还是热播的综艺大全最新影片，这里应有尽有。
                平台每日精选更新，保证高清画质流畅不卡顿，让您随时随地免费观看心仪内容。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8 animate-fade-in-up animation-delay-300">
                {[
                  { icon: 'ri-movie-2-line', label: '海量片库', value: '10万+资源' },
                  { icon: 'ri-tv-line', label: '每日更新', value: '30+新片' },
                  { icon: 'ri-hd-line', label: '高清画质', value: '1080P起步' },
                ].map((stat) => (
                  <div key={stat.label} className="flex items-center gap-2 text-white/80">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10">
                      <i className={`${stat.icon} text-accent-400 text-sm`}></i>
                    </div>
                    <div>
                      <p className="text-xs text-white/50 whitespace-nowrap">{stat.label}</p>
                      <p className="text-sm font-semibold whitespace-nowrap">{stat.value}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 animate-fade-in-up animation-delay-400">
                <a
                  href="#cards"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector('#cards');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 text-center"
                >
                  <i className="ri-play-circle-line mr-2"></i>开始观影
                </a>
                <a
                  href="#about"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector('#about');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 text-center backdrop-blur-sm border border-white/15"
                >
                  了解更多
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20composition%20featuring%20a%20glowing%20theater%20screen%20with%20warm%20ambient%20light%2C%20velvet%20curtains%20in%20deep%20burgundy%20tones%20framing%20the%20scene%2C%20golden%20spotlight%20effects%20creating%20dramatic%20atmosphere%2C%20sophisticated%20movie%20viewing%20experience%20visual%2C%20rich%20dark%20wood%20tones%20and%20brass%20accents%2C%20modern%20cinema%20aesthetic%20with%20classic%20elegance%2C%20no%20text%2C%20no%20people%2C%20abstract%20film%20art%20style&width=1040&height=780&seq=hero-cinema-visual&orientation=landscape"
                  alt="成全影院观影体验"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 rounded-2xl border border-white/10 pointer-events-none"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}